import styles from './index.module.less'
import React, { useState, useEffect, useRef } from 'react'

interface IProps {
  scrollId?: string
  className?: string
  style?: React.CSSProperties
  children?: React.ReactNode
}
const BackgroundImageLazy = (props: IProps) => {
  const { className, style, children, scrollId } = props
  const bgRef = useRef(null)
  const [lazied, setLazied] = useState(false)

  useEffect(() => {
    observeDom('init')
    const el = document?.getElementById(scrollId)
    const eventTarget = el || document
    eventTarget?.addEventListener?.('scroll', observeDom)

    return () => {
      eventTarget?.removeEventListener?.('scroll', observeDom)
    }
  }, [])

  const observeDom = type => {
    const isViewport = isInViewport(bgRef.current)
    // 加载完成后的无需再次加载
    setLazied(
      type === 'init' ? isViewport : isViewport || bgRef.current?.style?.backgroundImage !== 'none',
    )
  }

  const isInViewport = (element: Element) => {
    const viewWidth = window.innerWidth || document.documentElement.clientWidth
    const viewHeight = window.innerHeight || document.documentElement.clientHeight
    const { top, right, bottom, left } = element.getBoundingClientRect()
    return top >= 0 && top <= viewHeight && left >= 0
  }

  return style?.backgroundImage ? (
    <div
      className={`${styles.backgroundImageLazyComponent} ${className || ''}`}
      ref={bgRef}
      style={{ ...style, backgroundImage: !lazied ? 'none' : style?.backgroundImage }}
    >
      {children || null}
    </div>
  ) : null
}

export default BackgroundImageLazy
